import React, { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";
import { FcViewDetails, FcPackage, FcServices, FcInTransit, FcShipped } from "react-icons/fc";
import { MdPestControlRodent, MdClear } from "react-icons/md";
import { ImArrowRight } from "react-icons/im";
import { RxSlash, RxCaretRight } from "react-icons/rx";

import './InfoReportFlow.scss';
import { t } from "i18next";

const InfoReportFlow = () => {
    const _order_string = t('form-strings.info-page.flow.order');
    const _process_string = t('form-strings.info-page.flow.process');
    const _dispatch_string = t('form-strings.info-page.flow.dispatch');
    const _pest_free_string = t('form-strings.info-page.flow.pest-free');

    return <div className="render-info-report-flow-operation">
        <Row style={{margin: 'auto'}}>
            <Col xs={3}>
                <div className="pest-submit-icon">
                    <span className="ip-title">{_order_string}</span>
                    <div className="ip-form">
                        <FcViewDetails size={'60%'}/>
                    </div>
                    <div className="ip-arrow">
                        <ImArrowRight color={'green'} size={'60%'}/>
                    </div>
                    <div className="ip-separator">
                        <RxCaretRight color={'lightgrey'} size="60%"/>
                    </div>
                </div>
            </Col>
            <Col xs={3}>
                <div className="pest-service-icon">
                    <span className="ip-title">{_process_string}</span>
                    <div className="ip-service">
                        <FcServices size={'60%'}/>
                    </div>
                    <div className="ip-separator">
                        <RxCaretRight color={'lightgrey'} size="60%"/>
                    </div>
                </div>
            </Col>
            <Col xs={3}>
                <div className="pest-delivery-icon">
                    <span className="ip-title">{_dispatch_string}</span>
                    <div className="ip-package">
                        <FcPackage size={'100%'}/>
                    </div>
                    <div className="ip-truck">
                        <FcInTransit size={'60%'}/>
                    </div>
                    <div className="ip-separator">
                        <RxCaretRight color={'lightgrey'} size="60%"/>
                    </div>
                </div>
            </Col>
            <Col xs={3}>
                <div className="pest-removal-icon">
                    <span className="ip-title">{_pest_free_string}</span>
                    <div className="ip-pest">
                        <MdPestControlRodent size={'60%'}/>
                    </div>
                    <div className="ip-cross">
                        <MdClear color={'red'} size={'100%'}/>
                    </div>
                </div>
            </Col>
        </Row>
    </div>
}

export default InfoReportFlow;